module.exports = __webpack_public_path__ + "static/iac-8de4e428fce5625a380aec4a220878cd.svg";